module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/issue-02f443e2da7fdcacff29cd7271416fba.svg";